import { ContextStore } from 'bernie-core';
import { getBexApiContext } from 'bernie-graphql';

import { PropertyInfo } from '__generated__/api';

export const getPropertyInfoInput = (context: ContextStore, propertyId: string): PropertyInfo.Variables => ({
  context: getBexApiContext(context),
  propertyId
});
